export default "---\ntitle: FAQs\nhide_title: false\nunlisted: true\n---\n\n## Coming Soon\n"